import type { ProductPropertyKey } from "@/features/sub-families/types";

export const PROPERTY_DYNAMIC = "dynamic";

export const PART_SMART_NUMBER_PREFIX = "PART";

export const EMPTY_CONFIG_CODE = "0";

export const CUSTOM_FILTER_SORT_ORDER: ProductPropertyKey[] = ["cct", "cri", "beam_angle"];
